import React from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { StarSharp } from "@mui/icons-material";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { CompanyLogo } from "../../../../components/CompanyLogo";
import { HgProduct } from "../../../../types/taxonomy";

interface Props {
  items: HgProduct[];
  onViewAllProducts: () => void;
}

export const ProductsList: React.FC<Props> = ({ items, onViewAllProducts }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: "19px",
      }}
    >
      <Typography variant="h5">{`Products (${items.length})`}</Typography>

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {items.slice(0, 10).map(({ vendor, name, id }) => (
          <div
            key={id}
            style={{
              display: "flex",
              gap: "8px",
            }}
          >
            <div>
              <CompanyLogo
                domain={vendor?.url || ""}
                size={20}
                fallback={<StarSharp />}
                variant="circular"
              />
            </div>
            <div style={{ flex: 1 }}>
              <Link
                href={`/catalog/product/product/${id}`}
                underline="none"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/catalog/product/product/${id}`);
                }}
              >
                <Typography variant="body1" color="primary">
                  {name}
                </Typography>
              </Link>
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "start",
        }}
      >
        <Button
          id="view-all-products-button"
          data-testid="catalog-preview-viewall-btn"
          variant="text"
          onClick={onViewAllProducts}
        >
          view all products
        </Button>
      </div>
    </div>
  );
};
